/** Datums- und Zeitangaben auf Deutsch, in deutscher Zeit (Konzept 3: eine Zeitzone für alle). */
export const ZONE = 'Europe/Berlin';

export const WEEKDAYS = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'] as const;
export const WEEKDAYS_SHORT = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'] as const;

export function formatDay(day: string): string {
  const date = new Date(`${day}T12:00:00Z`);
  return new Intl.DateTimeFormat('de-DE', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' }).format(date);
}

export function formatDayShort(day: string): string {
  const date = new Date(`${day}T12:00:00Z`);
  return new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', timeZone: 'UTC' }).format(date);
}

export function formatTime(iso: string): string {
  return new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit', timeZone: ZONE }).format(new Date(iso));
}

export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  const day = new Intl.DateTimeFormat('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: ZONE }).format(date);
  return `${day}, ${formatTime(iso)} Uhr`;
}

export function formatDateTimeShort(iso: string): string {
  const date = new Date(iso);
  const day = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric', timeZone: ZONE }).format(date);
  return `${day} ${formatTime(iso)}`;
}

/** Heutiges Datum als 'YYYY-MM-DD' in deutscher Zeit. */
export function todayKey(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: ZONE }).format(new Date());
}

/** „16:00 Uhr, Mittwoch, 29. Juni 2022" – der gewählte Termin in der linken Spalte der Buchungsseite. */
export function formatTimeThenDate(iso: string): string {
  const date = new Date(iso);
  const day = new Intl.DateTimeFormat('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: ZONE }).format(date);
  return `${formatTime(iso)} Uhr, ${day}`;
}

/* Monatskalender: alles rechnet mit Tagesschlüsseln 'YYYY-MM-DD' und Monatsschlüsseln 'YYYY-MM' – ohne Zeitzonenfragen. */

export function monthKeyOf(day: string): string {
  return day.slice(0, 7);
}

export function addMonths(month: string, n: number): string {
  const [y, m] = month.split('-').map(Number) as [number, number];
  const date = new Date(Date.UTC(y, m - 1 + n, 1));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
}

export function formatMonth(month: string): string {
  return new Intl.DateTimeFormat('de-DE', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${month}-01T12:00:00Z`));
}

/** Alle Tage eines Monats als 'YYYY-MM-DD'. */
export function monthDays(month: string): string[] {
  const [y, m] = month.split('-').map(Number) as [number, number];
  const count = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return Array.from({ length: count }, (_, i) => `${month}-${String(i + 1).padStart(2, '0')}`);
}

/** Wochentag eines Tages, Montag = 0 … Sonntag = 6. */
export function weekdayIndex(day: string): number {
  return (new Date(`${day}T12:00:00Z`).getUTCDay() + 6) % 7;
}
